/***
 *
 *   ONBOARDING LAYOUT
 *   Phase 13 — AuthLayout twin for /app/onboarding. Same branding panel +
 *   theme toggle as reference `_auth.tsx`, with a wider form column (max-w-lg)
 *   so ProgressSteps and project privacy fields fit.
 *
 **********/

import { Button, useTheme } from 'components/lib';
import { AuthBrandingTicketBackdrop } from 'components/auth/brandingBackdrop';
import { useTranslate } from 'app/translations';
import Style from './onboarding.tailwind.js';

export function OnboardingLayout(props) {
    const { isDark, toggleTheme } = useTheme();
    const { _t } = useTranslate();

    return (
        <div className={Style.shell}>
            <aside className={Style.branding}>
                <AuthBrandingTicketBackdrop />
                <div className={Style.brandingCopy}>
                    {/* alt="" — the <h1> below already says "Valetify" */}
                    <img src="/assets/icon.png" alt="" className={Style.logo} />
                    <h1 className={Style.brandTitle}>Valetify</h1>
                    <p className={Style.brandTagline}>{_t('branding.tagline')}</p>
                </div>
            </aside>

            <div className={Style.formPanel}>
                <div className={Style.themePin}>
                    <Button
                        variant="ghost"
                        size="sm"
                        icon={isDark ? 'sun' : 'moon'}
                        iconButton
                        ariaLabel={_t(
                            isDark ? 'landing.nav.theme.toLight' : 'landing.nav.theme.toDark',
                        )}
                        action={toggleTheme}
                    />
                </div>
                <div className={Style.formInner}>
                    <props.children {...props.data} />
                </div>
            </div>
        </div>
    );
}
